<template>
  <div>
    <Form :model="searchData" inline>
      <!-- v-if="company == 1" -->
      <div>
        <!-- <FormItem label="">
          <Select
            style="width:200px"
            v-model="searchData.companyId"
            filterable
            :placeholder="
              $t(
                'permission_configuration_management.common.pleaseSelectCompany'
              )
            "
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem> -->
        <FormItem label="" v-if="companyId == 1">
          <Select
            style="width:200px"
            v-model="searchData.companyId"
            filterable
            :placeholder="
              $t(
                'permission_configuration_management.common.pleaseSelectCompany'
              )
            "
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="">
          <Input
            v-model="searchData.alertRuleName"
            style="width:200px"
            placeholder="请输入报警规则名称"
          ></Input>
        </FormItem>
        <FormItem label="">
          <Input
            v-model="searchData.name"
            style="width:200px"
            placeholder="请输入业务应用名称"
          ></Input>
        </FormItem>

        <Button type="primary" @click="getData">查询</Button>
        <span @click="search()">
          <Button
            type="primary"
            @click="handleShowModal"
            v-hasPermission="['aiMonitor:operatingSystem:add_application']"
            >添加应用</Button
          >
        </span>
      </div>
    </Form>

    <Modal
      v-model="modal"
      title="添加应用"
      :loading="loading"
      @on-ok="operatingSystemSubmit('operatingSystemForm')"
      @on-cancel="operatingSystemReset('operatingSystemForm')"
      :mask-closable="false"
    >
      <Form
        ref="operatingSystemForm"
        :model="operatingSystemForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <FormItem label="公司" v-if="companyId == 1" prop="companyId">
          <Select
            v-model="operatingSystemForm.companyId"
            filterable
            :placeholder="$t('alarm_contact.selectByCompany')"
            :transfer="true"
            style="width:300px;"
          >
            <Option value=" " selected>{{
              $t("alarm_contact.allType")
            }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 名称 -->
        <FormItem label="应用名称" prop="name">
          <Input
            v-model="operatingSystemForm.name"
            placeholder="Enter something..."
            style="width:300px;"
          ></Input>
        </FormItem>
        <FormItem label="规则名称" prop="alertRuleName">
          <Input
            v-model="operatingSystemForm.alertRuleName"
            placeholder="Enter something..."
            style="width:300px;"
          ></Input>
        </FormItem>
        <!-- 通知对象 -->
        <FormItem label="通知对象" prop="notificationObject">
          <Select
            filterable
            v-model="operatingSystemForm.notificationObject"
            multiple
            style="width:300px;"
          >
            <Option
              v-for="item in notificationObjectList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 报警方式 -->
        <FormItem label="报警方式" prop="noticeType">
          <Select
            filterable
            v-model="operatingSystemForm.noticeType"
            multiple
            style="width:300px;"
            @on-change="selectnoticeType(operatingSystemForm.noticeType)"
          >
            <Option
              v-for="item in alarmWayList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>

        <!-- 邮箱模板 -->
        <div v-show="isShowEmail">
          <FormItem label="邮箱模板" prop="emailModal">
            <Input
              v-model="operatingSystemForm.emailModal"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 8 }"
              style="width:300px;"
              disabled
            ></Input>
          </FormItem>
        </div>

        <!-- 企业微信模板 -->
        <div v-show="isShowWeChat">
          <FormItem label="企业微信模板" prop="wechatModal">
            <Input
              v-model="operatingSystemForm.wechatModal"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 8 }"
              style="width:300px;"
              disabled
            ></Input>
          </FormItem>
        </div>

        <!-- 描述 -->
        <FormItem label="描述" prop="describe">
          <Input
            v-model="operatingSystemForm.describe"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="Enter something..."
            style="width:300px;"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import TableOperatingSystem from "../operating_system/TableOperatingSystem";
var tableOperatingSystem = TableOperatingSystem;

var tableOperatingSystemVue = {};
export default {
  data() {
    return {
      companyId: getCookie(global.companyId),
      companyList: [],
      searchData: { companyId: "", alertRuleName: "", name: "" },
      loading: true,
      modal: false,
      isShowEmail: false,
      isShowWeChat: false,
      notificationObjectList: [],
      alarmWayList: [],
      operatingSystemForm: {
        companyId: "",
        name: "",
        notificationObject: [],
        noticeType: [],
        emailModal: "",
        wechatModal: "",
        describe: "",
        alertRuleName: ""
      },
      ruleValidate: {
        companyId: [{ required: true, message: "公司不能为空" }],
        name: [
          { required: true, message: "名称不能为空", trigger: "blur" },
          {
            type: "string",
            message: "名称为4-20个字符",
            pattern: "^.{4,20}$",
            trigger: "blur"
          }
        ],
        alertRuleName: [
          { required: true, message: "名称不能为空", trigger: "blur" },
          {
            type: "string",
            message: "名称为4-20个字符",
            pattern: "^.{4,20}$",
            trigger: "blur"
          }
        ],
        notificationObject: [
          {
            required: true,
            type: "array",
            message: "请选择通知对象",
            trigger: "change"
          }
        ],
        noticeType: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "请选择报警方式",
            trigger: "change"
          }
        ],
        describe: [
          { required: false, message: "请输入描述", trigger: "blur" },
          {
            type: "string",
            max: 10000,
            message: "最多输入10000个字符",
            trigger: "blur"
          }
        ]
      }
    };
  },
  beforeCreate: function() {
    tableOperatingSystemVue = this;
  },
  methods: {
    handleShowModal() {
      this.modal = true;
      this.getCompanyDropDownBox();
    },
    getData() {
      eventBus.$emit("companyId", this.searchData.companyId);
      eventBus.$emit("alertRuleName", this.searchData.alertRuleName);
      eventBus.$emit("name", this.searchData.name);
      console.log("searchData", this.searchData);
      tableOperatingSystem.methods.showAll();
    },
    // handleChangeCompanyId() {
    //   eventBus.$emit("companyId", this.searchData.companyId);
    //   tableOperatingSystem.methods.showAll();
    // },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    /**************************************  查询  **************************************/
    // 查询
    search: function() {
      this.queryContacts();
      this.alarmWay();
    },
    // 查询通知对象
    queryContacts: function() {
      tableOperatingSystemVue.$api.contact
        .queryContacts("monitorModule", 25)
        .then(res => {
          this.notificationObjectList = res.data.contactList;
        });
    },
    // 查询报警方式
    alarmWay: function() {
      tableOperatingSystemVue.$api.alertRule
        .alarmWay("userName", getCookie(global.cookieName))
        .then(res => {
          this.alarmWayList = res.data;
        });
    },
    // 查询邮件模板
    selectTemplate: function() {
      tableOperatingSystemVue.$api.briefReport
        .selectByModuleIndex({})
        .then(res => {
          this.operatingSystemForm.wechatModal = res.data.briefReportBodyWechat;
          this.operatingSystemForm.emailModal = res.data.briefReportBodyMail;
        });
    },
    //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
    selectnoticeType: function() {
      this.isShowEmail = false;
      this.isShowWeChat = false;
      for (var i = 0; i < this.operatingSystemForm.noticeType.length; i++) {
        if (this.operatingSystemForm.noticeType[i] == "0") {
          this.isShowEmail = true;
          this.noticeType = this.operatingSystemForm.noticeType;
          tableOperatingSystemVue.selectTemplate();
        }
        if (this.operatingSystemForm.noticeType[i] == "1") {
          this.isShowWeChat = true;
          this.noticeType = this.operatingSystemForm.noticeType;
          tableOperatingSystemVue.selectTemplate();
        }
      }
    },
    // 确定
    operatingSystemSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          var createAiApplication = {
            companyId: this.operatingSystemForm.companyId,
            name: this.operatingSystemForm.name,
            contactIds: this.operatingSystemForm.notificationObject,
            noticeTypes: this.operatingSystemForm.noticeType,
            description: this.operatingSystemForm.describe,
            alertRuleName: this.operatingSystemForm.alertRuleName
          };
          this.$api.aiMonitor
            .createAiApplication(createAiApplication)
            .then(res => {
              this.data = res.data;
              setTimeout(() => {
                tableOperatingSystem.methods.showAll();
                this.$refs[name].resetFields();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success("添加成功");
                this.isShowEmail = false;
                this.isShowWeChat = false;
                this.modal = false;
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error("添加失败");
        }
      });
    },
    // 取消
    operatingSystemReset: function(name) {
      this.isShowEmail = false;
      this.isShowWeChat = false;
      this.$refs[name].resetFields();
    }
  },
  mounted() {
    this.getCompanyDropDownBox();
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/ai_monitor/operating_system/AddOperatingSystem.vue